(function(){
  'use strict';
  const node=document.getElementById('db-locale-data');
  let data={locale:'en',messages:{}};
  try{if(node)data=JSON.parse(node.textContent);}catch{}
  function t(source,values={}){return String(data.messages[source]??source).replace(/%([a-zA-Z0-9_]+)%/g,(match,key)=>Object.hasOwn(values,key)?String(values[key]):match);}
  const locale=({en:'en-IE',de:'de-DE',nl:'nl-NL',fr:'fr-FR'})[data.locale.split('-')[0]]||'en-IE';
  window.DB_I18N={t,locale};
  document.documentElement.classList.remove('db-language-pending');
  const dialog=document.getElementById('db-language-dialog');
  if(!dialog)return;
  const key='db-language-confirmed-v1';let accepted=false,chosen=false;
  try{accepted=localStorage.getItem(key)===data.locale;}catch{}
  function show(){if(!dialog.open)dialog.showModal();}
  function remember(code){chosen=true;try{localStorage.setItem(key,code);}catch{}}
  document.querySelectorAll('[data-open-language]').forEach(button=>{
    button.setAttribute('aria-haspopup','dialog');
    button.setAttribute('aria-controls','db-language-dialog');
    button.addEventListener('click',show);
  });
  // Each form carries its own language, also for repeat switches and without JS.
  dialog.querySelectorAll('.db-language-form').forEach(form=>form.addEventListener('submit',event=>{
    const code=form.querySelector('input[name="language_code"]').value;
    remember(code);
    if(code===data.locale){event.preventDefault();dialog.close();return;}
    // Preserve the current page and Shopify preview parameters.
    if(window.location)form.querySelectorAll('input[name="return_to"]').forEach(input=>{
      input.value=window.location.pathname+window.location.search+window.location.hash;
    });
  }));
  dialog.addEventListener('cancel',event=>{if(!accepted&&!chosen)event.preventDefault();});
  if(!accepted)show();
})();
